import axios from 'axios';

export const storeToken = (token) => {
  sessionStorage.setItem('authToken', token);
};

export const getToken = () => {
  return sessionStorage.getItem('authToken');
};

export const removeToken = () => {
  sessionStorage.removeItem('authToken');
};

export const fetchToken = async () => {


  try {

    const api = axios.create({ baseURL: '/api' }); // mantém '/api'

    const response = await api.get(
      `/auth/GenerateToken`
    );

    const token = response.data.access_token;

    storeToken(token);
    return token;

  } catch (error) {
    console.error('Erro ao buscar o token:', error.message);
    throw error;
  }
};
